import { render, staticRenderFns } from "./HtmlSitemap.vue?vue&type=template&id=2c857fa8&scoped=true&"
import script from "./HtmlSitemap.vue?vue&type=script&lang=js&"
export * from "./HtmlSitemap.vue?vue&type=script&lang=js&"
import style0 from "./HtmlSitemap.vue?vue&type=style&index=0&id=2c857fa8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c857fa8",
  null
  
)

export default component.exports